// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.column .is-offset-one-quarter {
  margin-left: 12% !important;
}

.user-bulk-cr .top-align {
  margin-top: 10%;
  color: #565c78;
}
.user-bulk-cr .top-align .is-half {
  width: 60%;
}
.user-bulk-cr .top-align .is-half p {
  font-weight: 600;
  font-size: 14px;
  word-spacing: 2px;
  margin-bottom: 10px;
}
.user-bulk-cr .top-align .is-half .card-content {
  padding: 2.5rem 1.5rem;
}
.user-bulk-cr .right-align {
  margin-left: 16px;
  margin-bottom: 20px;
}
.user-bulk-cr .right-align i.fa {
  cursor: pointer;
  font-size: 14px !important;
  line-height: 30px;
}
.user-bulk-cr .file-upload-nxt {
  margin-left: 10%;
}
.user-bulk-cr ul {
  list-style: inherit;
}
.user-bulk-cr ul li {
  line-height: 30px;
  font-size: 15px;
}
.user-bulk-cr .mar-l {
  margin-left: 10%;
}

@media screen and (min-width: 320px) and (max-width: 768px) {
  .column .is-offset-one-quarter {
    margin-left: 0% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/userandgroup/user/new-user/new-user.scss"],"names":[],"mappings":"AACE;EACE,2BAAA;AAAJ;;AAKE;EACE,eAAA;EACA,cAAA;AAFJ;AAII;EACE,UAAA;AAFN;AAGM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AADR;AAGM;EACE,sBAAA;AADR;AAKE;EACE,iBAAA;EACA,mBAAA;AAHJ;AAKI;EACE,eAAA;EACA,0BAAA;EACA,iBAAA;AAHN;AAWE;EACE,gBAAA;AATJ;AAWE;EACE,mBAAA;AATJ;AAUI;EACE,iBAAA;EACA,eAAA;AARN;AAYE;EACE,gBAAA;AAVJ;;AAcA;EAEI;IACE,0BAAA;EAZJ;AACF","sourcesContent":[".column{\n  .is-offset-one-quarter{\n    margin-left: 12% !important;\n  }\n}\n\n.user-bulk-cr {\n  .top-align {\n    margin-top: 10%;\n    color: #565c78;\n\n    .is-half {\n      width: 60%;\n      p {\n        font-weight: 600;\n        font-size: 14px;\n        word-spacing: 2px;\n        margin-bottom: 10px;\n      }\n      .card-content {\n        padding: 2.5rem 1.5rem;\n      }\n    }\n  }\n  .right-align {\n    margin-left: 16px;\n    margin-bottom: 20px;\n\n    i.fa {\n      cursor: pointer;\n      font-size: 14px !important;\n      line-height: 30px;\n    }\n  }\n  .field {\n      .file {\n        // margin-right: 20%;\n      }\n  }\n  .file-upload-nxt {\n    margin-left: 10%;\n  }\n  ul {\n    list-style: inherit;\n    li {\n      line-height: 30px;\n      font-size: 15px;\n    }\n  }\n\n  .mar-l {\n    margin-left: 10%;\n  }\n}\n\n@media screen and (min-width: 320px) and (max-width: 768px) {\n  .column{\n    .is-offset-one-quarter{\n      margin-left: 0% !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
